import React from 'react';
import PropTypes from 'prop-types';

import {
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
  FormControl,
  InputLabel
} from '@material-ui/core';

import useStyles from './commonStyles';
import CustomInputLabel from './CustomInputLabel';

const Select = props => {
  const classes = useStyles();
  const { variant = 'standard', customLabel = true, label, name, value, onChange, disabled, options = [], showEmptyOption, emptyOptionLabel, helperText, ...rest } = props;

  return (
    <FormControl fullWidth variant={variant}>
      {customLabel ? <CustomInputLabel id={`select-${name}`}>{label}</CustomInputLabel> : <InputLabel id={`multiselect-${name}`}>{label}</InputLabel>}
      <MuiSelect
        labelId={`select-${name}`}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        fullWidth={true}
        inputProps={{
          classes: {
            icon: classes.selectIcon,
            root: classes.select
          },
        }}
        {...rest}
        displayEmpty={showEmptyOption && !!emptyOptionLabel}
      >
        {showEmptyOption ? <MenuItem value="">{emptyOptionLabel || '&nbsp;'}</MenuItem> : null}
        {options.map(option => <MenuItem key={`select-${name}-${option.value}`} value={option.value}>{option.label}</MenuItem>)}
      </MuiSelect>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};

Select.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  options: PropTypes.array, // {label: 'foo', value: 'bar'}
  showEmptyOption: PropTypes.bool,
  emptyOptionLabel: PropTypes.string,
  helperText: PropTypes.string,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  customLabel: PropTypes.bool
};

export default Select;
